/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3VIcon20Solid = forwardRef('UiMenuDots3VIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.874 3.749a1.874 1.874 0 1 1-3.747 0 1.874 1.874 0 0 1 3.747 0Z" }),
        React.createElement("path", { d: "M11.874 10a1.874 1.874 0 1 1-3.748 0 1.874 1.874 0 0 1 3.748 0Z" }),
        React.createElement("path", { d: "M10 18.122a1.874 1.874 0 1 0 0-3.747 1.874 1.874 0 0 0 0 3.747Z" })));
});
